import React, { useState } from 'react';
import BodyContainer from '../ui/BodyContainer';
import forgotPasswordStyles from '../styles/forgotPasswordStyles';
import CustomButton from '../ui/viewEventUi/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextFieldComp from '../ui/TextFieldComp';
import Loader from '../ui/Loader';
import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import Services from '../services/services';
import { isEmail } from '../regexFuncs';
import { backArrow } from '../ui/icons';
import CustomDialog from '../ui/customDialog';
import HeadText from '../ui/resetPassword/HeadText';

const useStyles = makeStyles((theme) => forgotPasswordStyles(theme));

function Payment() {
  const classes = useStyles();

  const [loader, setLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const history = useHistory();
  const [email, setEmail] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });

  const onChangeEmail = (e) => {
    const value = (e.target.value || '').trim();
    setEmail({
      error: false,
      helpertext: ' ',
      value: value,
    });
  };
  const Validation_fun = () => {
    if (!email.value) {
      setEmail({
        error: true,
        helpertext: 'Email address is required',
      });
    } else if (!isEmail(email.value)) {
      setEmail((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Email address is not valid',
        };
      });
      return false;
    } else {
      return true;
    }
  };

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      forgot_fun();
    }
  };

  const forgot_fun = () => {
    if (Validation_fun()) {
      setLoader(!loader);
      Services.forget_password_api(email.value)
        .then((responce) => {
          if (responce.data.responseCode === 200) {
            setLoader(false);
            toast.success(responce.data.details, { duration: 8000 });
            setDialogOpen(true);
            // history.push('/login');
          } else {
            setLoader(false);
            toast.error(responce.data.details, { duration: 8000 });
          }
        })
        .catch((error) => {
          setLoader(false);
          // toast.error(error);
          console.log(error);
        });
    }
  };

  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <BodyContainer title='Forgot Password' icon={backArrow(handleBackButton)}>
      <Grid container className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <HeadText
            headText='Forgot your password?'
            captionText='Resetting your password is simple. Please tell us the email address associated with your 2Gathers account'
            emailTextContainer={classes.emailTextContainer}
          />
          <div className={classes.horizontalLine} />
          <TextFieldComp
            name='EmailAddress'
            label='Email Address *'
            placeholder='Email Address'
            error={email.error}
            helpertext={email.helpertext}
            value={email.value}
            onChange={onChangeEmail}
            handleEnter={handleEnter}
            inputStyles={classes.inputStyles}
          />

          <div className={classes.btnContainer}>
            <CustomButton
              btnStyle={classes.button1}
              clickHandle={() => history.goBack()}
              btnText={'Cancel'}
            />

            <CustomButton
              btnStyle={classes.button}
              clickHandle={forgot_fun}
              btnText={'Reset'}
            />
          </div>

          <CustomDialog
            open={dialogOpen}
            handleClose={() => {
              // setDialogOpen(false);
              // history.push('/');
            }}
            popOverContainer={classes.popOverContainer}
            titleText={"Let's reset your password"}
            contentText={`A reset password email has been sent to ${email.value}. Please click on the reset password link to set a new password.`}
            btnOkCls={classes.btnStyleJoin}
            handleOk={() => {
              // setDialogOpen(false);
              history.push('/');
            }}
            btnOkText={'back to Sign in'}
            arrowIconCls={classes.arrowIcon}
          ></CustomDialog>
        </Paper>
        <Toaster position='top-center' />
      </Grid>
      <Loader open={loader} />
    </BodyContainer>
  );
}

export default Payment;
